import { render, staticRenderFns } from "./FrameContent.vue?vue&type=template&id=4a3d2f84&scoped=true&"
import script from "./FrameContent.vue?vue&type=script&lang=js&"
export * from "./FrameContent.vue?vue&type=script&lang=js&"
import style0 from "./FrameContent.vue?vue&type=style&index=0&id=4a3d2f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3d2f84",
  null
  
)

export default component.exports